import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Pricing from './components/Pricing';
import Services from './components/Services';
import Gallery from './components/Gallery';
import Reviews from './components/Reviews';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import BookingButton from './components/BookingButton';
import HolidayNotice from './components/HolidayNotice';

function App() {
  return (
    <div className="font-sans text-gray-800 antialiased selection:bg-rose-gold selection:text-white">
      <Navbar />
      <HolidayNotice />
      <main>
        <Hero />
        <Pricing />
        <Services />
        <Gallery />
        <Reviews />
        <FAQ />
        <Contact />

        <section className="py-24 bg-rose-gold relative overflow-hidden">
          <div className="absolute inset-0 bg-black/10"></div>
          <div className="container mx-auto px-4 relative z-10 text-center">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6">
              Ready to hear clearly again?
            </h2>
            <p className="text-white/90 text-lg mb-8 max-w-2xl mx-auto">
              Book your appointment today and experience professional ear care
              in Dudley and Wolverhampton.
            </p>
            <div className="flex justify-center">
              <BookingButton
                text="Book Your Appointment"
                variant="white"
                className="text-lg px-10 py-4 shadow-xl"
              />
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default App;
